import React, { type ReactElement } from 'react';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { xcss, Stack, Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { NoOptionComponentType } from '@atlassian/jira-jql-builder-basic/src/common/types.tsx';
import messages from './messages.tsx';

type Props = {
	children: ReactElement;
};

const MessageContainer = ({ children }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.150" xcss={stackStyles} alignInline="center">
			{children}
			<Text color="color.text">{formatMessage(messages.noOptionsPrimaryMessage)}</Text>
			<Text size="small" color="color.text.subtle">
				{formatMessage(messages.noOptionsSecondaryMessage)}
			</Text>
		</Stack>
	);
};

export const NoOptionsMessage: NoOptionComponentType = () => {
	return (
		<MessageContainer>
			<ErrorIcon
				label=""
				color={token('color.icon')}
				LEGACY_primaryColor={token('color.icon.subtle')}
			/>
		</MessageContainer>
	);
};

const stackStyles = xcss({
	paddingBlock: 'space.150',
	paddingInline: 'space.100',
});
